import { groupBy, keys } from 'lodash';
import Select from '../controls/Select';
import { getHotelList } from '../apis/hotelApis';
import { language } from '../common/constants';
import Button from 'react-bootstrap/Button';
import { Col, Form, Row } from 'react-bootstrap';
import { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { isEmbed } from '../utils/urlUtils';
import { useQuery } from '@tanstack/react-query';

export const SearchTabContent = styled.div`
  padding: 8px 0;
`;
SearchTabContent.displayName = 'SearchTabContent';

export const SearchForm = () => {
  const { data } = useQuery({
    queryKey: ['/api/hotels'],
    queryFn: getHotelList,
  });
  const [hotelId, setHotelId] = useState<number>();

  const locations = groupBy(data, (item) => item.location);
  const groupedOption = keys(locations).flatMap((item) => [
    {
      label: item,
      options: [
        ...locations[item].map((item) => ({
          label: item.hotelName,
          value: item.hotelId,
        })),
      ],
    },
  ]);

  const navigate = useNavigate();
  const handleSubmit = () => {
    navigate(isEmbed() ? `/embed/${hotelId}` : `/search/${hotelId}`);
  };
  const isValid = Boolean(hotelId);

  return (
    <div>
      <div>
        <Form.Label className="required">{language.CHOOSE_LOCATION_TITLE}</Form.Label>
        <div>
          <Select
            isSearchable
            placeholder={language.BRANCH}
            options={groupedOption}
            value={hotelId}
            onChange={(value: number) => setHotelId(value)}></Select>
        </div>
      </div>
      <Row>
        <Col className="d-grid offset-md-4 mt-3" sm={12} md={4}>
          <Button disabled={!isValid} onClick={handleSubmit} type="submit">
            Tìm Phòng
          </Button>
        </Col>
      </Row>
    </div>
  );
};
